<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/access">アクセス</router-link></li>
          <li><router-link to="/access/bus">バスをご利用の方</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ACCESS<span>アクセス</span></h2>
        <AccessMenu :accessMenuChild="accessMenu" />
        <div class="tab-content">
          <div id="content--3" class="access__content content--3">
            <h2>HARUMI FLAG敷地内のバス停留所</h2>
            <div class="img_holder">
              <img
                src="@/assets/img/access/access_img_1.jpg"
                alt="access map"
              />
            </div>
            <BusListLink :BusListLinkChild="busListLink" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CONSTANT from "../../../constant";
import { RouterLink } from "vue-router";

export default {
  name: "Bus",
  components: {
    AccessMenu: () => import("@/components/common/AccessMenu.vue"),
    BusListLink: () => import("@/components/common/access/BusListLink.vue"),
  },
  data() {
    return {
      accessMenu: CONSTANT.dataAccessMenu,
      busListLink: CONSTANT.dataBusListLink,
    };
  },
  computed: {},
};
</script>